import { inject, Injectable, Signal, signal } from '@angular/core';

import { AuthService } from '../auth/auth.service';
import { Role } from '../auth/role.enum';
import { User, UserDataIdp } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly authService = inject(AuthService);
  private readonly currentUserState = signal<User>(this.mapUserDataIdpToUser((this.authService.getUserData() ?? null) as UserDataIdp | null));

  readonly currentUser: Signal<User> = this.currentUserState.asReadonly();

  constructor() {
    this.authService.isAuthenticated$().subscribe(() => {
      this.currentUserState.set(this.mapUserDataIdpToUser((this.authService.getUserData() ?? null) as UserDataIdp | null));
    });
  }

  hasRole(role: Role): boolean {
    return this.currentUser().roles.includes(role);
  }

  private mapUserDataIdpToUser(userDataIdp: UserDataIdp | null): User {
    const rawRoles = userDataIdp?.roles;
    const roles = Array.isArray(rawRoles)
      ? rawRoles
      : typeof rawRoles === 'string' && rawRoles.length > 0
        ? [rawRoles]
        : [];

    return {
      subject: userDataIdp?.sub ?? '',
      givenName: userDataIdp?.given_name ?? '',
      familyName: userDataIdp?.family_name ?? '',
      email: userDataIdp?.email ?? '',
      provider: userDataIdp?.provider ?? '',
      roles: roles.filter((role): role is Role => Object.values(Role).includes(role as Role)),
    };
  }
}
